import * as types from "../../actions/ActionTypes";

const initialState = {
    loading: false,
    data: null,
    error: null,
};

const postJobReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.POST_JOB_START:
            return { ...state, loading: true, error: null };

        case types.POST_JOB_SUCCESS:
            return { ...state, loading: false, data: action.payload, error: null };

        case types.POST_JOB_ERROR:
            return { ...state, loading: false, error: action.payload };

        case types.POST_JOB_RESET:
            return initialState;

        default:
            return state;
    }
};

export default postJobReducer;
